/* 🤖 this file was generated by svg-to-ts */
export const matIconRoundedCorner: {
  name: 'rounded-corner';
  data: string;
} = {
  name: 'rounded-corner',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z"/></svg>`
};
